import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { LibraryInventoriesGetInventory, ToxnotServiceClient } from '../../../store/ToxnotServiceClient';
import { ToxnotComponentProperties } from '../BaseApplicationComponents/ToxnotComponent';
import { ToxnotSignInRequiredComponent } from '../BaseApplicationComponents/ToxnotSignInRequiredComponent';
import { LoadingSpinner, LoadingSpinnerSize } from '../LoadingSpinner';

import './styles.css';

interface OwnProps {
    onInventorySelected?: (inventory: LibraryInventoriesGetInventory) => void;
}

export type Props = ToxnotComponentProperties & OwnProps;

enum UiState {
    Loading,
    Failed,
    Selecting
}

interface FetchParameters {
    pageIndex: number;
    viewMaterials: boolean;
    folderId: string | null;
    searchQuery: string;
}

interface LocalState extends FetchParameters {
    uiState: UiState;
    pageOfInventories: LibraryInventoriesGetInventory[];
    totalNumberOfInventories: number;
}

// ===============================================================================

class SelectLibraryInventory extends ToxnotSignInRequiredComponent<Props, LocalState> {
    private readonly _serviceClient: ToxnotServiceClient;
    private readonly _rowsPerPage = 100;

    // ===============================================================================

    public constructor(props: Props) {
        super(props);

        this._serviceClient = new ToxnotServiceClient();

        this.state = {
            uiState: UiState.Loading,
            pageIndex: 0,
            viewMaterials: false,
            pageOfInventories: [],
            folderId: null,
            searchQuery: "",
            totalNumberOfInventories: 0
        };
    }

    // ===============================================================================

    protected override getDisallowedRoles() {
        return [];
    }

    // ===============================================================================

    public async componentDidMount() {
        this.fetchCurrentPageOfInventories(this.state);
    }

    // ===============================================================================

    /**
     * Splits a search query into an array of search terms. Used to parse
     * the search query for public inventories.
     * 
     * @param searchQuery The user-entered search query
     * 
     * @returns an array of terms parsed from the query
     */
    private splitSearchTerms(searchQuery: string): string[] {
        searchQuery = searchQuery.trim();

        let i = 0;

        const terms: string[] = [];

        while (i < searchQuery.length) {
            while ((i < searchQuery.length) && (searchQuery[i] == ' ')) {
                // skip whitespace
                ++i;
            }

            let nextTerm = "";

            if ((i < searchQuery.length) && (searchQuery[i] == '\"')) {
                // if it's quoted, extract until we find the end quote
                ++i;

                while ((i < searchQuery.length) && (searchQuery[i] != '\"')) {
                    nextTerm += searchQuery[i];
                    ++i;
                }

                if (i < searchQuery.length) {
                    ++i;
                }
            }
            else {
                // normal search term... extract until end or space or quote
                while ((i < searchQuery.length) && (searchQuery[i] != ' ') && (searchQuery[i] != '\"')) {
                    nextTerm += searchQuery[i];
                    ++i;
                }
            }

            if (nextTerm.length > 0) {
                terms.push(nextTerm);
            }
        }

        return terms;
    }

    // ===============================================================================

    private async fetchCurrentPageOfInventories(fetchParameters: FetchParameters) {
        this.setState({ uiState: UiState.Loading });

        const searchTerms = this.splitSearchTerms(fetchParameters.searchQuery);

        const apiResult = await this._serviceClient.libraryInventoriesGetForUserFilteredSortedAndPaged(
            fetchParameters.viewMaterials,
            searchTerms,
            fetchParameters.folderId,
            this._rowsPerPage,
            fetchParameters.pageIndex
        );

        if ((apiResult === null) || (apiResult.result !== "Ok")) {
            this.enterFailedState();
            return;
        }

        this.setState({
            uiState: UiState.Selecting,
            pageOfInventories: apiResult.pageOfInventories,
            totalNumberOfInventories: apiResult.totalNumberOfInventories
        });
    }

    // ===============================================================================

    private enterFailedState() {
        this.setState({
            uiState: UiState.Failed
        });
    }

    // ===============================================================================

    private renderMainView() {
        return (
            <>
                <div className="product-material-selection-container view-selectors form-inline">
                    <div className={`btn-group view-selector-container product-material-selector ${(this.state.viewMaterials ? "" : "active")}`}>
                        <button type="button" className="btn btn-default selector" onClick={async e => { this.setState({ viewMaterials: false }); await this.fetchCurrentPageOfInventories({...this.state, viewMaterials: false}); } }>{this.localizeString("Products")}</button>
                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span className="caret"></span></button>
                        <ul className="dropdown-menu">
                        {/*    @if (Model.ProductsFolderRoot != null)*/}
                        {/*    {*/}
                        {/*        <li><a role="button" className="folder-selector" data-folder-id="">@Model.Localizer["Library"]</a></li>*/}
                        {/*        foreach (var childFolder in Model.ProductsFolderRoot.ChildFolders)*/}
                        {/*        {*/}
                        {/*            <li><a role="button" className="folder-selector" data-folder-id="@childFolder.FolderId">@childFolder.Name.NullOrEmptyCoalesce(Model.Localizer["Unnamed Folder"])</a></li>*/}
                        {/*        }*/}
                        {/*        <li className="divider"></li>*/}
                        {/*    }*/}
                        {/*    else*/}
                        {/*    {*/}
                        {/*        <li><a role="button">@Model.Localizer["There are no sub-folders."]</a></li>*/}
                        {/*    }*/}
                        </ul>
                    </div>
                    <div className={`btn-group view-selector-container product-material-selector ${(this.state.viewMaterials ? "active" : "")}`}>
                        <button type="button" className="btn btn-default selector" onClick={async e => { this.setState({ viewMaterials: true }); await this.fetchCurrentPageOfInventories({ ...this.state, viewMaterials: true }); } }>{this.localizeString("Materials")}</button>
                        <button type="button" className="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><span className="caret"></span></button>
                        <ul className="dropdown-menu">
                        {/*    @if (Model.MaterialsFolderRoot != null)*/}
                        {/*    {*/}
                        {/*        <li><a role="button" className="folder-selector" data-folder-id="">@Model.Localizer["Library"]</a></li>*/}
                        {/*        foreach (var childFolder in Model.MaterialsFolderRoot.ChildFolders)*/}
                        {/*        {*/}
                        {/*            <li><a role="button" className="folder-selector" data-folder-id="@childFolder.FolderId">@childFolder.Name.NullOrEmptyCoalesce(Model.Localizer["Unnamed Folder"])</a></li>*/}
                        {/*        }*/}
                        {/*        <li className="divider"></li>*/}
                        {/*    }*/}
                        {/*    else*/}
                        {/*    {*/}
                        {/*        <li><a role="button">@Model.Localizer["There are no sub-folders."]</a></li>*/}
                        {/*    }*/}
                        </ul>
                    </div>
                    <div className="input-group input-group-sm">
                        <input type="text" className="form-control search-text-input" placeholder={this.localizeString("Search by Name, Description, Plant, Supplier...")} value={this.state.searchQuery} onChange={e => this.setState({ searchQuery: e.target.value })} onKeyDown={async e => { if (e.key === "Enter") { await this.fetchCurrentPageOfInventories(this.state); } } } />
                        <span className="input-group-btn">
                            <button className="btn btn-default initiate-search-button btn-sm" type="button" onClick={e => this.fetchCurrentPageOfInventories(this.state) }><span className="glyphicon glyphicon-search" aria-hidden="true"></span></button>
                        </span>
                    </div>
                    {/*<a role="button" id="show-filters"><i className="fas fa-filter"></i> @Model.Localizer["Filters"]</a>*/}
                </div>
                <div>
                    <table className="table toxnot-table-v2">
                        <thead>
                            <tr>
                                <td>{this.localizeString("Name")}</td>
                                <td>{this.localizeString("Description")}</td>
                                <td>{this.localizeString("Plant")}</td>
                                <td>{this.localizeString("Supplier")}</td>
                                <td>{this.localizeString("Tags")}</td>
                                <td></td>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.pageOfInventories.map((inventory, inventoryIndex) => (
                                <tr key={inventoryIndex}>
                                    <td>{inventory.name}</td>
                                    <td>{inventory.description}</td>
                                    <td>{inventory.plantName}</td>
                                    <td>{inventory.supplierName}</td>
                                    <td>{inventory.tags.join(", ")}</td>
                                    <td>
                                        <button type="button" className="btn btn-default" onClick={e => this.selectButton_click(inventory)}>{this.localizeString("Select")}</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </>
            );
    }

    // ===============================================================================

    protected renderConcreteComponent() {
        let content: JSX.Element | null = null;

        if (this.state.uiState === UiState.Loading) {
            content = <LoadingSpinner size={LoadingSpinnerSize.Large} />
        }
        else if (this.state.uiState === UiState.Failed) {
            content = <div>{this.localizeString("Sorry, there was a problem accessing the service.")}</div>
        }
        else if (this.state.uiState === UiState.Selecting) {
            content = this.renderMainView();
        }

        return content;
    }

    // ===============================================================================

    private selectButton_click = (inventory: LibraryInventoriesGetInventory) => {
        if (this.props.onInventorySelected) {
            this.props.onInventorySelected(inventory);
        }
    }
}

export default connect(
    (state: ApplicationState, ownProps: OwnProps) => ({ appServices: state.appServices })
)(SelectLibraryInventory as any);
